import React, { useState } from 'react';
import { Link } from "react-router-dom";
import '../assets/css/Form.css';
import logo from '../assets/images/Logo.svg';
import { Form } from 'react-bootstrap';
import { Formik } from 'formik';
import  * as Yup from 'yup';
import { useNavigate  } from 'react-router-dom';
import { connect } from 'react-redux';
import { signupUser } from '../store/signup/async-actions';
import { links } from '../config/InfusionSoft'

function Registration() {
  const [userType, setUserType] = useState(null)
  const navigate = useNavigate();

  const initialValues = {
    user_type: '',
    // subscription_type: ''
  }

  const validationSchema = Yup.object().shape({
    user_type: Yup.string()
      .required("*User type is required"),
    // subscription_type: Yup.string()
    //   .required("*Subscription Type is required")
  });
  
  const formSubmit = async(values) => {
    
    // window.location.assign(links[values.user_type][values.subscription_type])
    // navigate("/client_registration")
    try {
      await validationSchema.validate(values, { abortEarly: false });
      if (values.user_type === 'client') {
        navigate("/client_registration");
        
      } else if (values.user_type === 'member') {
        navigate("/member_registration");
      }

    } catch (error) {
    
      console.error("Validation Error:", error);
    }
    
  }

  const setUserTypeField = (e, setFieldValue) => {
    let type = e.target.value
    setFieldValue('user_type', type)
    setUserType(type)
    if(type === 'client') setFieldValue('subscription_type', 'onetime')
  }
  const handleTermsClick = () => {
    navigate('/termsOfServices');
  };
  return (
    <div className="main-container form-bg-color form-bg-reg">
      <img src={logo} className="form-logo" alt="logo" />
      { (alert.length !== 0) ? alert : ''}
      <div className="form-container">
        <div className="form-label-header">Registration</div>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values, {setSubmitting, resetForm})=> {
            formSubmit(values, setSubmitting, resetForm);
              // setSubmitting(true);
          }}
        >
        {({ errors, touched, values, handleSubmit, handleBlur, handleChange, setFieldValue }) => (
          <Form className="reg-form" onSubmit={handleSubmit}>
          <Form.Select aria-label="Default select example"  as="select" name="user_type" value={values.user_type}  onChange={(e) => setUserTypeField(e, setFieldValue)} onBlur={handleBlur}>
              <option value="">Register as</option>
              <option value="client">Client</option>
              <option value="member">Member</option>
              {/* <option value="recruiter">Recruiter</option> */}
            </Form.Select>
            {errors.user_type && touched.user_type ? <div className={`red mb-1 fs15`} style={{fontSize:'15px', color:'red'}} >{errors.user_type}</div> : null}

            {/* <Form.Control as="select" name="user_type" value={values.user_type} className={`${values.user_type === "" ? ' placeholder' : ''} form-input ${errors.user_type && touched.user_type ? 'error' : ''}`} onChange={(e) => setUserTypeField(e, setFieldValue)} onBlur={handleBlur} custom >
              <option value="">Register as</option>
              <option value="client">Client</option>
              <option value="member">Member</option>
              <option value="recruiter">Recruiter</option>
            </Form.Control> */}
            {/* {
              userType === 'member' || userType === 'recruiter' ? (
                <div>
                  <Form.Control as="select" name="subscription_type" value={values.subscription_type} className={`${values.subscription_type === "" ? ' placeholder' : ''} form-input ${errors.subscription_type && touched.subscription_type ? 'error' : ''}`} onChange={handleChange} onBlur={handleBlur} custom >
                    <option value="">Subscription Type</option>
                    <option value="annual">Annual</option>
                    <option value="monthly">Monthly</option>
                    {
                      userType === 'member' ? <option value="month_to_month">Month to month</option> : ''
                    }
                  </Form.Control>
                  {errors.subscription_type && touched.subscription_type ? <div className={`red mb-1 fs15`} >{errors.subscription_type}</div> : null}
                </div>
              ) : null
            } */}

            <span className="form-reg-terms">By clicking “Sign Up”, I agree to the terms and conditions of COGEN</span>

            <button type="submit" className="btn-signup">SIGN UP</button>

            <span className="text-link-to">Already A Member? <Link to="/login" className="btn-link"><strong>Log In</strong></Link> </span>
            <span className="text-link-to"><Link 
            to="/termsOfServices"
            className="btn-link"  onClick={handleTermsClick} ><strong>Terms and Conditions</strong></Link> </span>
          </Form>
        )}
        </Formik>
      </div>

    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    issignup: state.signup.isSuccess
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    signupUser: (values) => dispatch(signupUser(values)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Registration);